// extracted by mini-css-extract-plugin
export default {"container":"TimeMarker_container__QhZZf","line":"TimeMarker_line__beKO3","text":"TimeMarker_text__vI2oD"};